var map = {
	"./cancelled_delivery.svg": "9474",
	"./cancelled_pickup.svg": "6421",
	"./completed_delivery.svg": "8ba8",
	"./completed_pickup.svg": "a178",
	"./disabled.svg": "a109",
	"./in_progress_delivery.svg": "fe06",
	"./in_progress_pickup.svg": "1cce",
	"./scheduled.svg": "5f57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3a5e";